import { motion } from "framer-motion";
import { ShieldCheck, Zap, Download, ArrowRight } from "lucide-react";
import GuaranteeSeal from "./GuaranteeSeal";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;

const perks = [
  { icon: Download, text: "Download imediato em PDF após a compra" },
  { icon: Zap, text: "Leitura direta: aplique no mesmo dia" },
  { icon: ShieldCheck, text: "7 dias de garantia incondicional" },
];

const Offer = () => (
  <section id="oferta" className="relative px-6 py-28 sm:py-36 lg:px-12">
    <div className="mx-auto max-w-4xl">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
      >
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Oferta de lançamento</p>
        <h2 className="font-serif-display mt-6 text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
          Comece hoje.
          <span className="italic text-[#D4AF37]"> Cobre como profissional amanhã.</span>
        </h2>
      </motion.div>

      <motion.div
        className="relative mt-24"
        initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <GuaranteeSeal />
        <div className="beam-card">
        <div data-testid="offer-pricing-card" className="relative z-10 px-8 py-14 text-center sm:px-16 sm:py-20">
          <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA] sm:text-xs">
            Social Media na Prática · E-book completo
          </p>

          <div className="mt-10 flex flex-col items-center gap-2">
            <span className="text-sm text-[#71717A] line-through sm:text-base">De R$ 97,00</span>
            <div className="flex items-end justify-center gap-2">
              <span className="font-serif-display text-2xl text-[#D4AF37]">R$</span>
              <span className="font-serif-display gold-shimmer px-2 pb-3 text-7xl font-bold leading-[1.1] sm:text-8xl">17</span>
              <span className="font-serif-display pb-1 text-2xl text-[#D4AF37]">,97</span>
            </div>
            <span className="font-mono-label mt-2 text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Pagamento único · acesso vitalício</span>
          </div>

          <div className="mx-auto mt-12 grid max-w-md gap-4 text-left">
            {perks.map((perk, i) => (
              <div key={i} className="flex items-center gap-4">
                <perk.icon className="h-5 w-5 shrink-0 text-[#D4AF37]" strokeWidth={1.5} />
                <span className="text-sm text-[#A1A1AA] sm:text-base">{perk.text}</span>
              </div>
            ))}
          </div>

          <a
            data-testid="monetizze-checkout-button"
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-12 inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-10 py-5 text-sm font-bold uppercase tracking-[0.15em] text-[#0A0A0A] transition-all duration-300 hover:bg-[#F3E5AB] hover:shadow-[0_0_50px_rgba(212,175,55,0.35)] sm:w-auto"
          >
            Quero o e-book agora
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </a>

          <div data-testid="guarantee-badge" className="mt-8 inline-flex items-center gap-2 text-[#71717A]">
            <ShieldCheck className="h-4 w-4 text-[#D4AF37]" />
            <span className="text-xs">Compra segura via Monetizze · 7 dias de garantia</span>
          </div>
        </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Offer;
